import request from "@/utils/request";

export function newCourseDetail(data) {
  return request({
    url: "/course/newcoursedetail",
    method: "post",
    data
  });
}

export function searchCourseList(params) {
    return request({
        url: "/course/searchcourselist",
        method: "get",
        params:params
    });
}
